var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"news-filter__btns"},_vm._l((_vm.filters),function(filter){return _c('li',{key:filter.id,staticClass:"news-filter__btn",class:{'selected': _vm.selected.id == filter.id},on:{"click":function($event){return _vm.selectFilter(filter)}}},[_c('span',{domProps:{"textContent":_vm._s(filter.title)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }